export default String.raw`
.ai-reccommended-in-popup {
    clip-path: inset(-100vw -100vw -100vw 1px);

    &__title {
        margin: 32px 0 16px 0 !important;
        @include h4-headline;
    }
}
`